// extracted by mini-css-extract-plugin
module.exports = {"menu":"header-module--menu--3bKjy"};